/*global $*/
/*eslint no-undef: "error"*/
export default class Review {
    classBlock = 'review--block'
    classButton = 'review--button'

    classBlockOpen = 'review-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classBlock}`).addClass(self.classBlockOpen)
        })
    }
}
